/**
 * Created by kachavas on 1/21/16.
 */
var EABError = require('core-js-error');

angular
  .module('ui-ng-popover')
  .constant(
    'popoverDataEnum',
    Enumeration('popoverDataEnum', {
      DEFAULT: {
        title: 'Use popoverDataEnum',
        content:
          'Use popoverDataEnum to add popover data to your application, This helps maintain all your popover data in one place. use data-enum attribute with key on smartPopover to add data'
      }
    })
  )
  .service('popoverDataService', function (popoverDataEnum) {
    this.update = this.updateEnum = function update(Enum) {
      popoverDataEnum.union(Enum);
    };

    this.replace = this.replaceEnum = function replace(Enum) {
      popoverDataEnum.replace(Enum);
    };

    this.add = this.set = function add(name, values) {
      var enumObj = {};
      if (_.isUndefined(name)) {
        throw new EABError('popoverDataService', 100, 'Popover Data Enumeration object needs a name');
      } else if (_.isUndefined(values)) {
        throw new EABError('popoverDataService', 100, {
          key: name,
          details: 'Popover Data Enumeration object needs values for title and content'
        });
      } else if (_.isUndefined(values.title)) {
        throw new EABError('popoverDataService', 100, {
          key: name,
          details: 'Popover Data Enumeration object needs values for title'
        });
      } else if (_.isUndefined(values.content)) {
        throw new EABError('popoverDataService', 100, {
          key: name,
          details: 'Popover Data Enumeration object needs values for content'
        });
      }
      enumObj[name] = values;
      popoverDataEnum.add(enumObj);
    };

    var getDataByKey = function getDataByKey(enumKey) {
      return popoverDataEnum.get(enumKey);
    };

    this.get = this.getPopoverDataForKey = function getPopoverDataForKey(enumKey) {
      var data = getDataByKey(enumKey);
      return _.isEmpty(data) ? {} : data.value;
    };

    this.getPopoverTitle = function getPopoverTitle(enumKey) {
      var data = getDataByKey(enumKey);
      return _.isEmpty(data) ? '' : data.value.title;
    };

    this.getPopoverContent = function getPopoverContent(enumKey) {
      var data = getDataByKey(enumKey);
      return _.isEmpty(data) ? '' : data.value.content;
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popover/src/custom/popover_data_service.js